const INITIAL_STATE = {
    pagamentos: 0,
    recebimentos: 0,
    atrasados: {
        pagamento: 0,
        recebimento: 0
    }
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
       
        case 'ACERTO_ANALISE_FETCH': {
            const pagamento = action.transacao.pagarValor
            const recebimento = action.transacao.receberValor
            const copyAtrasado = {...state.atrasados}

            copyAtrasado.pagamento = action.atrasados.pagamento
            copyAtrasado.recebimento = action.atrasados.recebimento
                       
            return { ...state, pagamentos: pagamento, recebimentos: recebimento, atrasados: copyAtrasado }
        }
        default:
            return state
    }
}